<template>

  <div class="shopHome">
    <!--头部-->
    <Header ref="childRef"/>

    <!-- 菜系分类 -->
    <section class="cuisine">
      <div class="container">
        <!--        <span class="foodNameSpan">纽约美食</span>-->
<!--        <span class="foodNameSpan">Shop List</span>-->
<!--        <button @click="getLocation()">获取当前位置</button>-->
<!--        <span>{{ textStr }}</span>-->

        <div class="typeDiv">
          <div class="category-label">
            <!--            <span>分类：</span>-->
            <span style="color: #3D3D3D;font-size: 20px;font-weight: 500">Categories：</span>
          </div>
          <div class="category-container">
            <div class="category-scroll">
              <div
                class="category-tag"
                v-for="(category, index) in categorieList"
                :key="index"
                @click="selectCategory(category)"
                :class="{ active: selectedCategory.includes(category.name) }"
              >
                {{ category.name }}
              </div>
            </div>
          </div>


        </div>


      </div>
    </section>

    <section class="shopList">
      <div class="container">
        <!--全部商铺 好评 人均-->
        <div class="seekDiv">
          <div class="allShopDiv">
<!--            <span style="color: #CCCCCC;font-size: 16px">All shops</span>-->
          </div>
          <div class="sortDiv">
<!--            &lt;!&ndash; 好评排序 &ndash;&gt;-->
<!--            <div class="filter-item" :style="ratingStyle" @click="toggleSort('rating')">-->
<!--              &lt;!&ndash;              <span>好评</span>&ndash;&gt;-->
<!--              <span>Positive comment</span>-->
<!--              <i class="el-icon-caret-bottom" :style="{ color: ratingIconColor, transform: ratingIconTransform }"></i>-->
<!--            </div>-->

<!--            &lt;!&ndash; 人均价格 &ndash;&gt;-->
<!--            <div class="filter-item" :style="priceStyle" @click="toggleSort('price')">-->
<!--              &lt;!&ndash;              <span>人均</span>&ndash;&gt;-->
<!--              <span>per capita</span>-->
<!--              <i class="el-icon-caret-bottom" :style="{ color: priceIconColor, transform: priceIconTransform }"></i>-->
<!--            </div>-->

<!--            &lt;!&ndash; 距离最近 &ndash;&gt;-->
<!--            <div class="filter-item" :style="shortDistanceStyle" @click="toggleSortNew('shortDistance')">-->
<!--              &lt;!&ndash;              <span>距离最近</span>&ndash;&gt;-->
<!--              <span>Short distance</span>-->
<!--            </div>-->
<!--            <span style="margin-left: 1px">|</span>-->
<!--            &lt;!&ndash; 评价数量排序 &ndash;&gt;-->
<!--            <div class="filter-item" :style="opinionTotalStyle" @click="toggleSortNew('opinionTotal')">-->
<!--              &lt;!&ndash;              <span>评价数量</span>&ndash;&gt;-->
<!--              <span>Most Reviewed</span>-->
<!--            </div>-->
<!--            <span style="margin-left: 1px">|</span>-->
<!--            &lt;!&ndash; 评价平均分排序 &ndash;&gt;-->
<!--            <div class="filter-item" :style="averageScoreStyle" @click="toggleSortNew('averageScore')">-->
<!--              &lt;!&ndash;              <span>评价平均分</span>&ndash;&gt;-->
<!--              <span>Highest Rated</span>-->
<!--            </div>-->

            <!--排序改成下拉框形式 -->
            <div class="dropdown" @mouseenter="isOpen = true" @mouseleave="isOpen = false">
              <div class="dropdown-header">
                <span style="color: #B8B8B8;font-size: 15px;font-weight: 400">Sort：</span>
                <div style="display: inline-block;width: 110px">
                  <span style="color: #737373;font-size: 15px;font-weight: 400">{{ selectedOption }}</span>
                </div>
                <div style="display: inline">
                  <img style="width: 8px; height: 4.6px;margin-bottom: 2px" src="@/assets/daosanjiao.png">
                </div>
              </div>
              <div class="dropdown-content" v-show="isOpen">
                <div
                  class="dropdown-item"
                  :class="{ active: selectedOption === 'Distance' }"
                  @click="selectOption('Distance', 'shortDistance')"
                >
                  Distance
                </div>
                <div
                  class="dropdown-item"
                  :class="{ active: selectedOption === 'Most Reviewed' }"
                  @click="selectOption('Most Reviewed', 'opinionTotal')"
                >
                  Most Reviewed
                </div>
                <div
                  class="dropdown-item"
                  :class="{ active: selectedOption === 'Highest Rated' }"
                  @click="selectOption('Highest Rated', 'averageScore')"
                >
                  Highest Rated
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="shopListDiv">
          <div v-if="!isRedList" style="min-height: 398px; display: flex; justify-content: center; align-items: center; text-align: center">
<!--            <h2 style="color: #5B5B5B">数据读取中...</h2>-->
            <h2 style="color: #5B5B5B">Data reading...</h2>
          </div>
          <div v-else>
            <div v-if="items.length > 0" style="min-height: 398px">
              <el-row :gutter="100">
                <el-col :span="24" v-for="(item, index) in items" :key="index">
                  <el-card >
                    <el-row @click.native="funToShopDetail(item)" style="cursor: pointer;">
                      <el-col :span="5">
                        <div style="padding-right: 20px;width: 233px;height: 159px;margin: 16px 0;">
                          <img :src="imagePath + item.image" class="image" alt="Restaurant Image">
                          <!--                      <img :src=item.image class="image">-->
                          <el-tag v-if="item.isOpen" type="success">Open</el-tag>
                          <el-tag v-else type="danger">Close</el-tag>
                        </div>

                      </el-col>

                      <el-col :span="19">
                        <h3 style="margin-top: 16px;">{{ item.title }}</h3>
                        <div class="ccnew1">


<!--                          <img src="@/assets/scsl.png" style="width: 20px;">-->
<!--                          <div style="margin-top: 1px">-->
<!--                            <span style="color:#FF5733;font-size: 16px;">{{ item.rating }}</span>-->
<!--                          </div>-->
                          <div style="display: flex">
                            <el-rate
                              :value="Number(item.average_score)"
                              disabled
                              :colors="['#FF5733', '#FF5733', '#FF5733', '#FF5733', '#FF5733']"
                              style="display: inline-block;margin-right: 5px;margin-bottom: 4px;">
                            </el-rate>
                            <div style="margin-top: 1px">
                              <span style="color:#FF5733;font-size: 16px;">{{ item.average_score }}</span>
                            </div>
                          </div>
<!--                          <span style="margin-left:1vw">{{ item.shop_type_dictText }}</span>-->
                          <!-- 展开 biaoqian -->
                          <span
                            v-for="(tag, tagIndex) in  item.shop_type_dictText ?  item.shop_type_dictText.split(',') : []"
                            :key="tagIndex"
                            class="review-tag">
                            {{ tag.trim() }}
                          </span>

                        </div>

                        <!--                    <p style="margin-top: 3px">{{ item.description }}</p>-->
                        <p style="width: 80%;margin-top: 16px;"><img src="@/assets/locations.png" style="width: 16px">
                          {{ item.location }}</p>
                      </el-col>
                    </el-row>
                    <hr v-if="index !== items.length - 1" style="height: 1px; border: none; background-color: #EBEBEB; margin: 0px 0;">
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-else style="display: flex; justify-content: center; align-items: center">
              <img src="@/assets/noData.png">
            </div>
          </div>


          <div class="block" style="margin:2% 0 2% 0;text-align: right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="curpage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="count">
            </el-pagination>
          </div>
        </div>

      </div>

    </section>


    <!--底部-->
    <Footer/>
  </div>


</template>


<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import config from '../../config/config.js';
import {
  getSubscriptionsList
} from '../api/portal-api/portal.js';
import {getBqList} from "../api/test-api/test";

export default {
  name: 'ShopHome',
  components: {
    Header: Header,
    Footer: Footer
  },

  data() {
    return {
      isOpen: false, // 排序下拉菜单是否打开
      selectedOption: 'All Results',// 当前选中的选项
      // textStr : '',
      userLon:  '',//用户经度
      userLat:  '',//用户纬度
      isRedList: false,//是否查询数据 用于div显示
      searchShopText: '',//搜索商家内容
      imagePath: config.imagePath,   //图片地址前缀
      count: 0,
      curpage: 1,
      pagesize: 10,
      items: [
        // 商铺列表数据
        // {
        //   image: '@/assets/infinity-1535757.jpg',
        //   title: 'KPOT Korean BBQ & Hot Pot',
        //   rating: 14,
        //   description: 'bbg & hotpot',
        //   location: 'XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation,XYZ Corporation, 789 Business Blvd, Suite 200, Dallas, TX 75201',
        //   isOpen: true
        //   average_score: 评价平均分数
        // }
      ],
      // 颜色控制变量
      ratingTextColor: '#666',
      ratingIconColor: '#666',
      priceTextColor: '#666',
      priceIconColor: '#666',
      shortDistanceTextColor: '#666',
      opinionTotalTextColor: '#666',
      averageScoreTextColor: '#666',
      // 旋转控制
      ratingIconTransform: '',
      priceIconTransform: '',
      sortType: '', // 'rating'好评 或 'price'人均
      sortOrder: '', // 'asc' 或 'desc'
      checked: true, // 默认选中"全部商铺"
      // selectedCategory: '不限', // 默认选中"不限"
      // selectedCategory: 'All Results', // 默认选中"不限"
      // selectedCategoryId: 0, // 默认选中"不限"
      selectedCategory: ['All Results'], // 改为数组，存储选中的分类 name
      selectedCategoryIds: [0], // 存储选中的分类 id
      categorieList: [
        // { id: 0, name: '不限' },
        // { id: 1, name: '火锅' },
        // { id: 2, name: '北京烤鸭' },
        // { id: 3, name: '中餐' },
        // { id: 4, name: '海鲜' },
        // { id: 5, name: '烧烤' }
        {id: 0, name: 'All Results'},
        {id: 1, name: 'Hot Pot'},
        {id: 2, name: 'Peking Duck'},
        {id: 3, name: 'Chinese'},
        {id: 4, name: 'Seafood'},
        {id: 5, name: 'Barbecue'}
      ],

    }
  },
  computed: {
    // 好评样式计算属性
    ratingStyle() {
      return {
        color: this.ratingTextColor
      }
    },
    // 人均样式计算属性
    priceStyle() {
      return {
        color: this.priceTextColor
      }
    },
    // 距离最近样式计算属性
    shortDistanceStyle() {
      return {
        color: this.shortDistanceTextColor
      }
    },
    // 评价数量排序样式计算属性
    opinionTotalStyle() {
      return {
        color: this.opinionTotalTextColor
      }
    },
    // 评价平均分排序样式计算属性
    averageScoreStyle() {
      return {
        color: this.averageScoreTextColor
      }
    },

  },

  created() {
    //获取当前用户经纬度
    this.getLocation();

  },
  mounted() {  // ✅ 使用 mounted 确保子组件存在
    if (this.$route.query.searchText) {
      this.searchShopText = this.$route.query.searchText
      // 通过 $refs 获取子组件实例并调用方法
      this.$refs.childRef.childMethod(this.searchShopText);
      console.log("子组件返回的数据:");
    }
    // 获取商铺的数据
    this.funGetSubDataList();
  },
  methods: {
    // 获取当前用户经纬度
    getLocation() {
      console.log('[1] 开始执行获取位置函数');

      // 1. 检查 navigator 对象是否存在
      if (!navigator) {
        console.error('错误：navigator 对象不存在（可能在不支持的运行环境中）');
        return;
      }

      // 2. 检查浏览器是否支持地理定位API
      if (!navigator.geolocation) {
        console.error('错误：浏览器不支持地理定位API');
        return;
      }

      console.log('[2] 正在尝试获取位置...');

      // 3. 设置定位选项（提高精度，设置超时时间）
      const options = {
        enableHighAccuracy: true,  // 尝试获取更精确的位置
        timeout: 10000,            // 10秒超时
        maximumAge: 0              // 不使用缓存位置
      };

      // 4. 调用定位API
      navigator.geolocation.getCurrentPosition(
        // 成功回调
        (position) => {
          console.log('[3] 获取位置成功:', position);
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // 更新显示文本
          // this.textStr = `定位成功！纬度: ${lat.toFixed(6)}, 经度: ${lng.toFixed(6)}`;
          console.log(`精确位置：纬度: ${lat}, 经度: ${lng}`);
          this.userLon = lng.toFixed(6);//用户经度
          this.userLat = lat.toFixed(6);//用户纬度

          // 这里可以添加发送到服务器的逻辑
          // this.sendLocationToServer(lat, lng);
        },

        // 失败回调
        (error) => {
          console.error('[3] 获取位置失败:', error);

          // 根据错误类型显示不同的错误信息
          switch (error.code) {
            case error.PERMISSION_DENIED:
              console.error('用户拒绝了位置权限');
              break;
            case error.POSITION_UNAVAILABLE:
              console.error('无法获取位置信息');
              break;
            case error.TIMEOUT:
              console.error('获取位置请求超时');
              break;
            default:
              console.error('未知定位错误', error);
          }
        },

        options  // 传入定位选项
      );

      console.log('[4] 已发送定位请求（异步操作）');
    },
    funToShopDetail(item) {
      console.log('点击了', item)
      this.$router.push({name: 'ShopDetail', query: {shopId: item.id}});
      // 在搜索结束后的方法中调用，滚动条回到顶部
      window.scrollTo({
        top: 0,
        // behavior: 'smooth' // 可选，平滑滚动
      });
      // 调整为跳转新开页面
      // const route = this.$router.resolve({
      //   name: 'ShopDetail',
      //   query: { shopId: item.id }
      // });
      // window.open(route.href, '_blank');
    },
    // 获取Header.vue组件的搜索内容
    handleSearch(text) {
      this.searchShopText = text
      this.funGetSubDataList()
    },
    submitForm() {
      // 表单提交逻辑
      console.log('表单提交:', this.form)
      // 这里可以添加表单验证和AJAX提交
    },
    // 选择分类的方法
    selectCategory(category) {
      // 1. 更新当前选中的分类
      // this.selectedCategory = category.name;
      // this.selectedCategoryId = category.id;
      const { name, id } = category;

      // 如果是 "All Results" (id=0)
      if (id === 0) {
        // 选中 "All Results" → 清空其他选项
        this.selectedCategory = [name];
        this.selectedCategoryIds = [id];
      }
      // 如果是其他选项
      else {
        // 先检查是否已选中
        const index = this.selectedCategory.indexOf(name);

        if (index === -1) {
          // 未选中 → 先移除 "All Results"（如果存在），再添加当前选项
          this.selectedCategory = this.selectedCategory.filter(item => item !== 'All Results');
          this.selectedCategoryIds = this.selectedCategoryIds.filter(itemId => itemId !== 0);
          this.selectedCategory.push(name);
          this.selectedCategoryIds.push(id);
        } else {
          // 已选中 → 移除当前选项
          this.selectedCategory.splice(index, 1);
          this.selectedCategoryIds.splice(index, 1);
          // 检查是否已经没有选中任何选项 → 自动回退到 "All Results"
          if (this.selectedCategory.length === 0) {
            this.selectedCategory = ['All Results'];
            this.selectedCategoryIds = [0];
          }

        }
      }

      // 2. 发送请求
      this.funGetSubDataList();
    },

    //  点击选项的方法
    selectOption(option, sortKey) {
      // 设置显示
      this.selectedOption = option;
      if (this.sortType == sortKey) {
        console.log('取消排序', sortKey)
        // 如果选中排序，再次点击则取消
        this.sortType = '';
        this.selectedOption = 'All Results';
      } else {
        console.log('排序', sortKey)
        this.sortType = sortKey;
      }
      this.isOpen = false; // 选中后关闭下拉菜单
      this.funGetSubDataList();
    },


    // 点击排序的方法
    toggleSort(type) {
      // 重置所有颜色状态
      this.resetAllColors();
      if (this.sortType === type) {
        console.log('取消排序1', this.sortType)
        if (this.sortType === 'rating') {
          console.log('取消排序2', this.sortType)
          // 如果选中好评排序，再次点击则取消
          this.sortType = '';
          this.sortOrder = '';
        } else {
          console.log('取消排序3', this.sortType)
          this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
          // 设置当前激活项的颜色和旋转
          this[`${type}TextColor`] = '#FF2424';
          this[`${type}IconColor`] = '#FF2424';
          this[`${type}IconTransform`] = this.sortOrder === 'asc' ? 'rotate(180deg)' : '';
        }
      } else {
        console.log('取消排序4', this.sortType)
        this.sortType = type;
        this.sortOrder = 'desc';
        this[`${type}TextColor`] = '#FF2424';
        this[`${type}IconColor`] = '#FF2424';
        this[`${type}IconTransform`] = '';
      }
      this.funGetSubDataList();
    },
    // 点击排序的方法 新方法不支持正序倒序
    toggleSortNew(type) {
      // 重置所有颜色状态
      this.resetAllColors();
      if (this.sortType === type) {
        console.log('取消排序', type)
        // 如果选中排序，再次点击则取消
        this.sortType = '';
      } else {
        console.log('选中排序', type)
        this.sortType = type;
        this[`${type}TextColor`] = '#FF2424';
      }
      this.funGetSubDataList();
    },
    // 查询商铺列表的方法
    funGetSubDataList() {
      // 给用户默认坐标 也是店铺的默认坐标
      this.userLon = this.userLon === '' ? '-84.3952659' : this.userLon
      this.userLat = this.userLat === '' ? '33.7556586' : this.userLat
      // 发送请求获取排序后的数据
      const params = {
        userLon: this.userLon,
        userLat: this.userLat,
        searchShopText: this.searchShopText,
        sortType: this.sortType,
        sortOrder: this.sortOrder,
        pageNo: this.curpage,
        pageSize: this.pagesize,
        shopTypeList: this.selectedCategoryIds[0] == 0  ? [] : this.selectedCategoryIds,
      };
      getSubscriptionsList(params).then(res => {
        // 数据读取完毕
        this.isRedList = true;
        this.items = res.list
        this.count = res.total
      })
      // 在搜索结束后的方法中调用，滚动条回到顶部
      window.scrollTo({
        top: 0,
        // behavior: 'smooth' // 可选，平滑滚动
      });

    },
    resetAllColors() {
      // 重置所有颜色为默认
      this.ratingTextColor = '#666';
      this.ratingIconColor = '#666';
      this.priceTextColor = '#666';
      this.priceIconColor = '#666';
      this.shortDistanceTextColor = '#666';
      this.opinionTotalTextColor = '#666';
      this.averageScoreTextColor = '#666';
      this.ratingIconTransform = '';
      this.priceIconTransform = '';
    },
    // 分页切换事件
    handleSizeChange(val) {
      console.log('分页切换事件', val)
      // this.loading = true
      this.pagesize = val
      this.curpage = 1
      this.funGetSubDataList()
    },
    // 跳页
    handleCurrentChange(val) {
      console.log('跳页', val)
      // this.loading = true
      // this.curpage = (val - 1) * 10 + 1
      this.curpage = val
      console.log('跳页this.curpage', this.curpage)
      this.funGetSubDataList()
    },
  }
}
</script>

<style scoped>
.shopHome {
  padding-top: 200px; /* 给固定导航栏留出空间 */
  background-color: #F6F6F6;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 32px;
  color: #333;
}

.cuisine-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  border-radius: 5px;
  background: #f9f9f9;
  transition: all 0.3s;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.feature-item i {
  font-size: 40px;
  color: #42b983;
  margin-bottom: 20px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.case-item {
  border: 1px solid #eee;
  border-radius: 5px;
  overflow: hidden;
}

.case-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.case-item h3 {
  padding: 15px;
  font-size: 18px;
}

.case-item p {
  padding: 0 15px 15px;
  color: #666;
}

.contact-content {
  display: flex;
  justify-content: space-between;
}

.contact-form {
  flex: 1;
  max-width: 500px;
}

.contact-form input,
.contact-form textarea {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.contact-form textarea {
  height: 120px;
}

.contact-form button {
  background: #42b983;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  cursor: pointer;
}

.contact-info {
  flex: 1;
  max-width: 400px;
  padding-left: 50px;
}

.contact-info p {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.contact-info i {
  margin-right: 10px;
  font-size: 20px;
  color: #42b983;
}

@media (max-width: 992px) {
  .cuisine-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cases-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .contact-content {
    flex-direction: column;
  }

  .contact-info {
    padding-left: 0;
    margin-top: 30px;
  }
}

@media (max-width: 576px) {
  .cuisine-grid {
    grid-template-columns: 1fr;
  }

  .cases-grid {
    grid-template-columns: 1fr;
  }
}

.foodNameSpan {
  width: 96px;
  height: 23px;
  font-weight: 500;
  font-size: 16px;
  color: #3D3D3D;
  line-height: 50px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

/* 分类标签网格 */
.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 15px;
  margin-top: 20px;
}

/* 单个分类标签 */
.category-tag {
  display: inline-block;
  padding: 0 15px;
  /*background: #f5f5f5;*/
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  /*width: 48px;*/
  height: 23px;
  font-weight: 500;
  font-size: 16px;
  color: rgba(61, 61, 61, 0.5);
  line-height: 23px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.category-tag:hover {
  background: #FF2424;
  color: white;
}

/* 选中状态的分类标签 */
.category-tag.active {
  background: #FF2424;
  color: white;
}

.typeDiv {
  width: 100%;
  height: auto;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #F0F0F0;
  display: flex;
  align-items: center;
  margin-top: 50px;
}

.category-label {
  flex-shrink: 0;
  margin-right: 70px;
  width: 48px;
  height: 23px;
  font-weight: 500;
  font-size: 16px;
  color: rgba(61, 61, 61, 0.5);
  line-height: 23px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}


.category-scroll {
  display: inline-flex;
  gap: 40px;
}

/*横向滚动布局*/
.category-container {
  width: 100%;
  /*overflow-x: auto;*/
  white-space: nowrap;
  /*padding-bottom: 5px; !* 给滚动条留空间 *!*/
}

/* 隐藏滚动条（可选） */
.category-container::-webkit-scrollbar {
  height: 5px;
}

.category-container::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 5px;
}

.seekDiv {
  width: 100%;
  height: 51px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中 */
  padding: 0 15px; /* 左右内边距，让内容向中间靠拢 */
  background: #FFFFFF;
  border-radius: 4px 4px 0 0;
  border: 1px solid #F0F0F0;
  border-bottom: none;

}

.shopListDiv {
  background-color: #0f4276;
  width: 100%;
  padding: 0 15px;
  background: #FFFFFF;
  border-radius: 0 0 4px 4px;
  border: 1px solid #F0F0F0;
  margin-bottom: 50px;
}

.allShopDiv /deep/ .el-checkbox__label {
  display: inline-block;
  padding-left: 4px;
  line-height: 19px;
  font-size: 14px;
}

.sortDiv {
  display: flex;
  gap: 20px;
  padding: 10px 0;
  /*border-bottom: 1px solid #f0f0f0;*/
}

.filter-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.filter-item:hover {
  color: #FF2424;
}

.filter-item i {
  margin-left: 4px;
  font-size: 12px;
  transition: transform 0.3s;
}

/*商铺列表相关样式*/
.image {
  /*width: 100%;*/
  width: 231px;
  height: 157px;
  border-radius: 4px;
  /*margin-top: 16px;*/
}

.el-tag {
  position: absolute;
  top: 26px;
  left: 10px;
}

/deep/ .el-card__body, .el-main {
  padding: 0 20px 0 20px;
  margin-top: 15px;
}

.container {
  width: 100%;
  max-width: 1446px;
  /*margin: 0 auto;*/
  padding: 0 15px;
  margin-bottom: 15px;
}

.ccnew1 {
  display: flex;
  align-items: center;
  margin-top: 16px;
  /*font-size: 3.5893vw;height: 5.86vw;*/
  /*color: rgba(91, 91, 91, 1);margin-top:2.9vw;*/
  /*width: 80%;*/
  /*padding-left:4.8vw;*/
  /*line-height: 5.86vw;*/
  /*background: url("@/assets/scsl.png") -2px center no-repeat;*/
  /*background-size: auto 80%;*/

}

/deep/ .el-card {
  border: none;
  /*border-bottom: 1px solid #EBEEF5;*/
}
/deep/.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover, .el-cascader__dropdown, .el-color-picker__panel, .el-message-box, .el-notification {
   -webkit-box-shadow:none;
}

.review-tag {
  display: inline-block;
  margin-left: 18px;
  padding: 0 6px;
  background-color: #F6F6F6;
  border-radius: 15px;
  font-size: 12px;
  color: #A1A1A1;
}

.ccnew1 /deep/ .el-rate__icon {
  font-size: 25px;
  margin-right: -1px;
  color: #C0C4CC;
}


/*这是下拉框弹窗样式*/
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-header {
  cursor: pointer;
  padding: 8px;
  /*border: 1px solid #ccc;*/
  /*border-radius: 4px;*/
  /*background-color: #f9f9f9;*/
}

.dropdown-content {
  position: absolute;
  background-color: #FFFFFF;
  min-width: 180px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 5px;
  overflow: hidden;
  padding: 12px 0;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  margin: 7px 13px;
  border-radius: 5px;
  color: #737373;
  text-align: center;
}

.dropdown-item:hover {
  background-color: #FFE5E5; /* 浅粉色背景 */
}

.dropdown-item.active {
  background-color: #FFE5E5; /* 选中项的浅粉色背景 */
  color: #B28080; /* 选中项的文字颜色 */
}

.arrow {
  margin-left: 5px;
}


/*分页插件背景色*/
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #FF2424;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// src/views/ShopHome.vue